const firstNames = [
  'Anna', 'Emma', 'Ida', 'Sofie', 'Freja', 'Clara', 'Laura', 'Ella', 'Alma', 'Karla',
  'Maja', 'Josefine', 'Olivia', 'Agnes', 'Nora', 'Signe', 'Mathilde', 'Asta', 'Lærke', 'Liva',
  'Caroline', 'Emilie', 'Marie', 'Julie', 'Cecilie', 'Louise', 'Camilla', 'Mette', 'Hanne', 'Lene',
  'Susanne', 'Tina', 'Pia', 'Birgitte', 'Helle', 'Karen', 'Kirsten', 'Inge', 'Lone', 'Charlotte',
  'Rikke', 'Maria', 'Stine', 'Trine', 'Line', 'Sara', 'Katrine', 'Malene', 'Dorthe', 'Gitte',
  'William', 'Noah', 'Oscar', 'Lucas', 'Carl', 'Victor', 'Malthe', 'Alfred', 'Emil', 'Oliver',
  'Magnus', 'Valdemar', 'Frederik', 'Elias', 'August', 'Aksel', 'Arthur', 'Johan', 'Anton', 'Viggo',
  'Mads', 'Lars', 'Jens', 'Peter', 'Michael', 'Søren', 'Henrik', 'Thomas', 'Martin', 'Niels',
  'Christian', 'Jesper', 'Morten', 'Rasmus', 'Anders', 'Kasper', 'Jakob', 'Mikkel', 'Simon', 'Jonas',
  'Kim', 'Ole', 'Hans', 'Jørgen', 'Bo', 'Torben', 'Steen', 'Per', 'Claus', 'Brian'
]

const lastNames = [
  'Jensen', 'Nielsen', 'Hansen', 'Pedersen', 'Andersen', 'Christensen', 'Larsen', 'Sørensen', 'Rasmussen', 'Jørgensen',
  'Petersen', 'Madsen', 'Kristensen', 'Olsen', 'Thomsen', 'Christiansen', 'Poulsen', 'Johansen', 'Møller', 'Mortensen',
  'Knudsen', 'Jakobsen', 'Mikkelsen', 'Olesen', 'Frederiksen', 'Laursen', 'Henriksen', 'Lund', 'Schmidt', 'Eriksen',
  'Holm', 'Kristiansen', 'Clausen', 'Simonsen', 'Svendsen', 'Andreasen', 'Iversen', 'Jeppesen', 'Mogensen', 'Jacobsen',
  'Nissen', 'Lauridsen', 'Kjær', 'Jespersen', 'Mathiesen', 'Hald', 'Dahl', 'Bertelsen', 'Vestergaard', 'Østergaard',
  'Nørgaard', 'Søndergaard', 'Lindberg', 'Bach', 'Friis', 'Berg', 'Kjeldsen', 'Lassen', 'Thygesen', 'Winther',
  'Juhl', 'Bruun', 'Overgaard', 'Damgaard', 'Bisgaard', 'Holst', 'Toft', 'Skov', 'Krogh', 'Brandt',
  'Munk', 'Koch', 'Dam', 'Beck', 'Bang', 'Mølgaard', 'Ravn', 'Kirkegaard', 'Engel', 'Steffensen'
]

export const MAX_RANDOM_NAMES = firstNames.length * lastNames.length

function randomItem (list) {
  return list[Math.floor(Math.random() * list.length)]
}

export function generateRandomNames (count, excludedNames = []) {
  const excluded = new Set(excludedNames.map(name => name.toLowerCase()))
  const names = new Set()
  const target = Math.min(count, MAX_RANDOM_NAMES - excluded.size)
  let attempts = 0

  while (names.size < target && attempts < target * 50) {
    const name = randomItem(firstNames) + ' ' + randomItem(lastNames)
    if (!excluded.has(name.toLowerCase())) {
      names.add(name)
    }
    attempts++
  }

  return Array.from(names)
}



// WEBPACK FOOTER //
// ./src/utils/randomNames.js